import React from 'react'


const QuizContext = React.createContext({
    score: 1,
    incScore: (num) => { }
});

export default QuizContext;